import { QuestionWithId } from 'pages/CampaignCreation/types';
import { QuestionType } from 'services/campaign/types';

type GetShouldShowAutomationStepProps = {
  hasATSJobID: boolean;
  hasATSListID: boolean;
  questions: QuestionWithId[];
};

export const getShouldShowAutomationStep = ({
  hasATSJobID,
  hasATSListID,
  questions
}: GetShouldShowAutomationStepProps): boolean => {
  if (hasATSJobID) return true;
  if (hasATSListID) return true;

  const hasDocumentQuestion = questions.some(
    (question) => question.questionType === QuestionType.DOCUMENT
  );

  return hasDocumentQuestion;
};
